// src/ui/components/SegmentedIconSelector.tsx
import * as React from "react";
import { Button } from "@src/ui/views/button";

export interface SegmentedOption<K extends string> {
  key: K;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

interface SegmentedIconSelectorProps<K extends string> {
  options: SegmentedOption<K>[];
  selected: K;
  onChange: (key: K) => void;
}

export function SegmentedIconSelector<K extends string>({
  options,
  selected,
  onChange,
}: SegmentedIconSelectorProps<K>) {
  return (
    <div className="flex space-x-2 mb-4">
      {options.map(({ key, label, Icon }) => {
        const isSelected = key === selected;
        return (
          <Button
            key={key}
            size="sm"
            variant={isSelected ? "default" : "outline"}
            className={`
              flex items-center space-x-1
              ${isSelected ? "ring-2 ring-offset-2 ring-blue-500" : ""}
            `}
            onClick={() => onChange(key)}
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </Button>
        );
      })}
    </div>
  );
}